/**
 * Curated Alternatives Catalog
 * 
 * Maps a product category/subcategory to a list of hand-picked, 
 * high-quality alternative product barcodes.
 * 
 * If a user scans a high-impact product in one of these categories, 
 * the app will recommend these exact products instead of relying 
 * strictly on the algorithmic Open Food Facts search.
 */

export const CURATED_ALTERNATIVES = {
    // Body Wash / Cleaners
    'body-wash': [
        '0812154030018', // Native Body Wash
        '0018787769656', // Dr. Bronner's Pure-Castile Liquid Soap
        '3337875597333', // CeraVe Hydrating Cleanser
    ],
    'shower-gel': [
        '0812154030018',
        '0018787769656',
    ],
    
    // Deodorants
    'deodorant': [
        '0812154030063', // Native Deodorant
        '0851703008404', // Schmidt's Natural Deodorant
    ],
    'antiperspirant': [
        '0812154030063', 
        '0851703008404',
    ],

    // Snacks & Chips
    'potato-chips': [
        '0859561005085', // Siete Grain Free Tortilla Chips
        '0853328006240', // PopCorners
        '0037600109312', // Bare Baked Crunchy Apple Chips
    ],
    'chips': [
        '0859561005085', 
        '0853328006240',
    ]
};
